@if (visible) {
	<div>
		<div
			id="{{ modalId }}Modal"
			role="dialog"
			aria-labelledby="modal-title"
			tabindex="-1"
			class="{{ UI_CONSTANTS.MODAL.BASE_MODAL_CLASS }} {{ customBorderRadius }}"
			eaAutoFocus
		>
			<div class="modal-dialog {{ size }}" [@dialog]>
				<div class="modal-content">
					<div
						class="modal-header d-flex align-items-center justify-content-between"
					>
						<ea-heading
							name="modal-title"
							[type]="HEADING_TYPES.h2"
							[size]="HEADING_SIZES.md"
						>
							<ng-container
								*ngTemplateOutlet="headingIconTemplate"
							></ng-container>
							{{ title }}</ea-heading
						>
						<button
							(click)="close()"
							type="button"
							class="close"
							aria-label="Close"
						>
							<span aria-hidden="true">
								<ea-icon class="close-icon" name="close"></ea-icon>
							</span>
						</button>
					</div>
					<div
						class="modal-body"
						[ngClass]="{ 'modal-body-bg': isModalBgWhite }"
						tabindex="0"
					>
						<!-- We need ngTemplateOutlet here so we can inject components into our modals and have
              them instantiate fresh each time and to avoid issues with angular life cycle
              instantiating components before they have all the data they need -->
						<ng-container *ngTemplateOutlet="modalBodyTemplate"></ng-container>
					</div>
				</div>
			</div>
		</div>
		<ea-ui-modal-overlay></ea-ui-modal-overlay>
	</div>
}
